module.exports = __webpack_public_path__ + "static/media/sun-down.d4a62536.png";